<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                  style="width: 100%; table-layout: fixed"
                >
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        style="width: 6%"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'id'"
                        ></span>
                      </td>
                      <td class="text-center align-middle" style="width: 13%">
                        Cliente
                      </td>
                      <td class="text-center align-middle" style="width: 9%">
                        Documento
                      </td>
                      <td class="text-center align-middle" style="width: 7%">
                        Status
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Depósito
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Automatizado
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Retenção de Imposto
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Email
                      </td>
                      <td class="text-center align-middle" style="width: 7%">
                        Telefone
                      </td>
                      <td class="text-center align-middle" style="width: 14%">
                        Endereço
                      </td>
                      <td class="text-center align-middle" style="width: 7%">
                        Segmento
                      </td>
                      <td class="text-center align-middle" style="width: 6%">
                        Tamanho
                      </td>
                      <td class="text-center align-middle" style="width: 7%">
                        Código CNAE Principal
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Descrição CNAE Principal
                      </td>
                      <td class="text-center align-middle" style="width: 12%">
                        Plano
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectCustomerStatuses
                          :first="'Todos'"
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.deposit"
                          @change="setFilter('deposit', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.isAutomated"
                          @change="setFilter('isAutomated', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.retention"
                          @change="setFilter('retention', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(customer, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ customer.id }}
                      </td>
                      <td class="text-left align-middle">
                        {{
                          customer.customerable.co_name
                            ? customer.customerable.co_name
                            : customer.customerable.name
                        }}
                      </td>
                      <td class="text-center align-middle">
                        {{
                          customer.documents
                            ? customer.documents.value
                            : '-' | cnpj | cpf
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        <span
                          class="m--font-success"
                          v-if="customer.status === 1"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Ativo</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 2"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Cancelado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 3"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Bloqueado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 4"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Congelado</span
                        >
                        <span
                          class="m--font-warning"
                          v-if="customer.status === 5"
                          v-b-tooltip.hover
                          :title="
                            customer.status_reason
                              ? customer.status_reason.status_reason
                              : 'Sem motivo'
                          "
                          >Mudança de documento</span
                        >
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.deposit ? 'Sim' : 'Não' }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.is_automated ? 'Sim' : 'Não' }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.retention ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="word-wrap: break-word"
                      >
                        {{ getEmail(customer) }}
                      </td>
                      <td class="text-center align-middle">
                        {{ getPhone(customer) }}
                      </td>
                      <td class="text-center align-middle">
                        {{ formatAddress(customer.address) }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.segment }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.size }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.cnae_code }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.description }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.plan }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                      >
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 2"
                        >{{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                        >{{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                        >{{ data.current_page + 1 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 2"
                        >{{ data.current_page + 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                      >
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.last_page"
                      >
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerModal v-if="showCustomerSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerModal from '@/components/customers/CustomerModal';
import SelectCustomerStatuses from '@/components/forms/SelectCustomerStatuses';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import SelectYesNo from '@/components/forms/SelectYesNo';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportCustomers',
  props: ['start', 'finish'],
  components: { CustomerModal, SelectCustomerStatuses, SelectYesNo },
  data() {
    return {
      data: {},
      sortType: localStorage.customerSortType
        ? localStorage.customerSortType
        : 'id',
      sortReverse: localStorage.customerSortReverse
        ? localStorage.customerSortReverse
        : false,
      amount: localStorage.customerDataAmount
        ? localStorage.customerDataAmount
        : 100,
      page: localStorage.customerDataPage ? localStorage.customerDataPage : 1,
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
        name: localStorage.customerFilterName
          ? localStorage.customerFilterName
          : '',
        cnpj: localStorage.customerFilterCnpj
          ? localStorage.customerFilterCnpj
          : '',
        status: localStorage.customerFilterStatus
          ? localStorage.customerFilterStatus
          : '',
        isAutomated: localStorage.customerFilterIsAutomated
          ? localStorage.customerFilterIsAutomated
          : 0,
        retention: localStorage.customerFilterRetention
          ? localStorage.customerFilterRetention
          : 0,
        deposit: localStorage.customerFilterDeposit
          ? localStorage.customerFilterDeposit
          : 0,
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/customer/report/download/${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_clientes`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.isAutomated = '';
      this.filters.deposit = '';
      this.filters.retention = '';
      this.filters.sortType = 'id';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
      localStorage.setItem('customerFilterName', this.filters.name);
      localStorage.setItem('customerFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerFilterStatus', this.filters.status);
      localStorage.setItem('customerDataAmount', this.amount);
      localStorage.setItem('customerDataPage', this.page);
      localStorage.setItem('customerSortType', this.sortType);
      localStorage.setItem('customerSortReverse', this.sortReverse);
      localStorage.setItem(
        'customerFilterIsAutomated',
        this.filters.isAutomated
      );
      localStorage.setItem('customerFilterRetention', this.filters.retention);
      localStorage.setItem('customerFilterDeposit', this.filters.deposit);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&amount=${
        this.amount
      }&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${
        this.finish ? this.finish : this.start
      }&isAutomated=${
        this.filters.isAutomated ? this.filters.isAutomated : ''
      }&deposit=${this.filters.deposit ? this.filters.deposit : ''}&retention=${
        this.filters.retention ? this.filters.retention : ''
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/report/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    formatAddress(addres) {
      const data = JSON.parse(addres)[0];
      return `${data.logradouro || ''}, Número: ${data.numero || ''}, Cidade: ${data.cidade || ''} - ${data.uf || ''}, CEP: ${data.cep || ''}`;
    },

    getEmail(customer) {
      if (customer.email) {
        return customer.email;
      }

      for (let i = 0; i < customer.contacts.length; i++) {
        const contact = customer.contacts[i];
        if (contact.email) {
          return contact.email;
        }
      }
    },

    getPhone(customer) {
      let phone = '';
      customer.contacts.forEach((contact) => {
        if (contact.phone) {
          phone = contact.phone;
        }
      });
      return phone;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
